export default {
  install: (Vue, options) => {
    const config = options.config;
    Vue.prototype.$getConfig = () => {
      return config;
    };
  },
};
